import styled from "styled-components";

export const StepperAndSummaryWrapper = styled.div`
  background: var(--Tokens-Gray-25, rgba(249, 249, 249, 1));
  max-width: 1200px;
  margin: 0 auto;
  border-radius: var(--dui-size-space-10x) var(--dui-size-space-10x) 0px 0px;
`;

export const ShipmentSummaryContainer = styled.div`
  display: flex;

  @media print {
    display: none;
  }
`;

export const SummaryIconWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const SummaryContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: var(--dui-size-space-10x);
`;

export const SummaryTitle = styled.div`
  color: var(--dui-color-red-500);
  font-size: var(--dui-size-font-xs);
  margin-bottom: var(--dui-size-space-3x);
  font-weight: bold;
`;

export const SummaryDetails = styled.div`
  display: flex;
  gap: var(--dui-size-space-10x);
  align-items: center;
  font-size: var(--dui-size-font-sm);
`;

export const DetailSection = styled.div`
  display: flex;
  gap: var(--dui-size-space-5x);
  align-items: center;
`;

export const DetailLabel = styled.div`
  font-weight: bold;
  color: var(--dui-color-black-500);
`;

export const DetailValue = styled.div`
  color: var(--dui-color-black-500);
  padding: 2px 2px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    border-color: var(--dui-colors-action-background-primary-disabled);
    background-color: var(--dui-colors-action-background-primary-disabled);
  }

  &:focus,
  &:focus-visible {
    outline: var(--dui-size-space-1x) solid #007acc;
    outline-offset: var(--dui-size-space-1x);
    z-index: 1;
  }
`;

export const ProductListWrapper = styled.div`
  margin-top: var(--dui-size-space-5x);
  display: flex;
  flex-wrap: wrap;
  column-gap: var(--dui-size-space-8x);
`;

export const StepperComponent = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--dui-color-yellow-500);
  border-radius: var(--dui-size-space-10x) var(--dui-size-space-10x) 0px 0px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media print {
    display: none;
  }
`;

export const StepperWrapper = styled.div`
  display: flex;

  @media print {
    display: none;
  }
`;

export const StepperContent = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  min-height: 145px;
  width: 100%;
`;

export const StepperSteps = styled.ul`
  display: flex;
  align-items: center;
  gap: var(--dui-size-space-4x);
  flex: 1;
  padding-left: var(--gaq-size-space-30px);
  padding-top: var(--dui-size-space-12x);
`;

export const StepCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--dui-size-space-24x);
  height: var(--dui-size-space-24x);
  border-radius: 50%;
  font-weight: bold;
  font-size: 18px;
  ${(props) =>
    props.status === "completed" &&
    `
      border: 2px solid var(--dui-color-green-500);
      background-color: var(--dui-color-green-500);
      color: #ffffff;
      cursor: pointer !important;
      
      &:hover {
        background-color: var(--dui-colors-action-background-primary-success-hover);
        border-color: var(--dui-colors-action-background-primary-success-hover);
      }
    `}
  ${(props) =>
    props.status === "active" &&
    `
      border: 2px solid #191919;
      background-color: #ffffff;
      color: #191919;
    `}
  ${(props) =>
    props.status === "pending" &&
    `
      border: 2px solid #8c8c8c;
      background-color: #ffffff;
      color: #8c8c8c;
    `}
  z-index: 2;
  & svg {
    fill: white;
  }
`;

export const StepLabel = styled.p`
  font-size: 14px;
  font-weight: ${(props) => (props.status === "active" ? "bold" : "normal")};
  color: ${(props) =>
    props.status === "pending"
      ? "var(--dui-colors-action-foreground-ghost-functional-disabled)"
      : "var(--dui-colors-icons-secondary)"};
  margin-top: var(--dui-size-space-4x);
  text-align: center;
  height: 30px;
  width: var(--gaq-size-space-120px);
  background: none;
  border: 2px solid transparent;

  ${(props) =>
    props.status === "completed" &&
    `
    &:hover {
      cursor: pointer;
      color: var(--dui-colors-action-foreground-ghost-functional-disabled);
    }
  `}
`;

export const StepContainer = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border-radius: 1px;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: var(--dui-size-space-1x) solid #007acc;
    outline-offset: var(--dui-size-space-5x);
    z-index: 1;
  }
`;

export const StepConnector = styled.div`
  height: var(--dui-size-space-1x);
  background-color: ${(props) =>
    props.completed
      ? "var(--dui-color-green-500)"
      : "var(--dui-color-gray-500)"};
  width: 100%;
  position: absolute;
  top: var(--dui-size-space-12x); /* Adjusted to center with larger circles */
  left: var(--dui-size-space-24x); /* Adjusted to match circle size */
  z-index: 1;
`;

export const IllustrationContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 350px;
  padding-right: ${(props) =>
    props.currentStep === 3 ? "var(--gaq-size-space-60px)" : "0px"};
`;

export const CornerNumberCircle = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--gaq-size-space-35px);
  font-weight: bold;
  color: #ffffff;
  right: -50px;
  top: 40%;
  transform: translate(-50%, -50%);
`;

export const CornerIconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: var(--dui-size-space-40x);
  width: var(--dui-size-space-50x);
  height: var(--dui-size-space-50x);
  z-index: 3;
`;

export const StepperSummaryWrapper = styled.div`
  height: auto;
  display: flex;
  justify-content: flex-start;
  gap: var(--gaq-size-space-30px);
  background: var(--dui-color-gray-50);
  padding: var(--dui-size-space-8x) var(--gaq-size-space-30px);
  border-bottom: 0.5px solid var(--dui-color-black-opacity-30);
  @media print {
    display: none;
  }
`;
